import StopCommentsCell from './container';

export default StopCommentsCell;
